module.exports = __webpack_public_path__ + "img/60.a6cf8aaa.png";